import { API_BASE } from "@/lib/api";

/* --- counting visits without following anyone -------------------------------
   The visit id below lives in a module variable and nowhere else. It is not a
   cookie, not localStorage, not sessionStorage: closing the tab ends it, and
   nothing is left on the visitor's machine to recognise them by tomorrow.

   That is the whole reason this site has no consent banner. Keep it that way —
   the moment this id is persisted, the banner becomes legally required. */

const VISIT = Math.random().toString(36).slice(2, 14);

const beacon = (payload) => {
  const url = `${API_BASE}/site/track`;
  const body = JSON.stringify({ ...payload, visit: VISIT });
  // sendBeacon survives the page being closed, which is exactly when the
  // interesting number — how long they stayed — is finally known
  if (navigator.sendBeacon) {
    navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
    return;
  }
  fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true })
    .catch(() => {});
};

let openedAt = 0;
let currentPath = "";

/** Report how long this page has been open. Safe to call repeatedly: the
    server keeps the longest duration it has seen for a visit and a page, so a
    reader who leaves, comes back and stays is not counted twice. */
const leave = () => {
  if (!currentPath) return;
  const elapsed = Date.now() - openedAt;
  if (elapsed < 1000) return;
  beacon({ path: currentPath, duration_ms: elapsed });
};

/** Record one page. Call again on every route change. */
export function trackPage(path) {
  if (path === currentPath) return;
  leave();

  currentPath = path;
  openedAt = Date.now();

  let zone = "";
  try {
    zone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch {
    zone = "";
  }

  beacon({
    path,
    referrer: document.referrer || "",
    lang: document.documentElement.lang || "",
    zone,
    width: window.innerWidth || 0,
  });
}

if (typeof window !== "undefined") {
  // pagehide fires where unload does not — notably when iOS Safari freezes a
  // backgrounded tab instead of closing it
  window.addEventListener("pagehide", leave);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") leave();
  });
}
